import { AppState } from '../../init/rootReducer';
import { LoginPageState } from './reducer';

const getLoginPageState = (state: AppState): LoginPageState => state.containers.login;

export default getLoginPageState;
